import AppointmentPrescription from "./AppointmentPrescription";
export default AppointmentPrescription;